export const SET_MESSAGES = 'SET_MESSAGES';
export const RESET_MESSAGES = 'RESET_MESSAGES';

export default {
  SET_MESSAGES,
  RESET_MESSAGES,
};



// WEBPACK FOOTER //
// ./src/store/modules/general/mutation-types.js